import { Navigate } from 'react-router-dom';
const getCookie = (name) => {
  const cookieString = `; ${document.cookie}`;
  const parts = cookieString.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop().split(';').shift();
  }
  return null;
};
export default function PrivateRoute({ children }) {
const TOKEN_KEY = 'token'; // ✅ Using the consistent key
  const COOKIE_NAME = 'portal_jwt';

  // 1. Declare one variable to hold the token, regardless of its source.
  // We check localStorage first.
  let authToken = localStorage.getItem(TOKEN_KEY);

  // 2. If the token wasn't in localStorage, check the cookie as a fallback.
  if (!authToken) {
    const tokenFromCookie = getCookie(COOKIE_NAME);

    // If we found it in the cookie, save it to localStorage for future use.
    if (tokenFromCookie) {
      console.log('✅ Found token in cookie. Moving it to localStorage.');
      localStorage.setItem(TOKEN_KEY, tokenFromCookie);
      authToken = tokenFromCookie; // Assign the value to our main variable

      // Clean up the cookie after moving it.
      document.cookie = `${COOKIE_NAME}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
    }
  }

  // 3. ✅ Now, use the consolidated authToken variable for the final check.
  if (!authToken) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
